import {navWidth, navWidthMini} from "../../../../@signals";
import { dsColorNew } from "@palette";
import { alpha } from "@mui/material/styles"

export const MaximalLayoutNavToggleButtonStyles = (theme, isMini) => ({
    p: 0,
    top: 84,
    width: "20px",
    height: "44px",
    borderRadius: '0 6px 6px 0',
    position: 'fixed',
    left: (isMini ? navWidthMini.value: navWidth.value),
    zIndex: theme.zIndex.appBar + 110,
    backgroundColor: dsColorNew.white,
    border: `1px solid ${dsColorNew.grayBorder}`,
    borderLeft: 'none',
    color: dsColorNew.textSubtle,
    boxShadow: `2px 0 6px ${alpha(dsColorNew.black, 0.06)}`,
    '&:hover': {
        backgroundColor: dsColorNew.pillTrackBg,
        color: dsColorNew.appBlue,
    }
})